import React               from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

export default function Entity({ quote, replaceQuote }) {
  if (!quote.partners || quote.partners.length === 0) return null

  const lockedId = quote.partner_frozen ? quote.partner_id : quote.client.partner_id
  const value    = lockedId || quote.partner_id || ""

  return (
    <div className="form-group">
      <label>{I18n.t("partners.issuing_partner")} *</label>
      { lockedId && <span className="ml-1" tooltip={I18n.t(quote.partner_frozen ? "partners.frozen_hint" : "partners.locked_hint")}><FontAwesomeIcon icon="info-circle" /></span> }
      <select
        className = "form-control h-41px"
        name      = "quote[partner_id]"
        value     = {value}
        required
        disabled  = {!!lockedId}
        onChange  = {e => replaceQuote({ ...quote, partner_id: parseInt(e.target.value) || null })}
      >
        <option value="">{I18n.t("client.partners.select_partner")}</option>
        { quote.partners.map(partner => <option key={partner.id} value={partner.id}>{partner.name}</option>) }
      </select>
    </div>
  )
}
